import React, { useEffect } from 'react'

const UserSettings = (props) => {
    const {
        permission,
        handlePermissionType,
        handleCostingPermission,
        checkedPermissions,
        formValues,
        clearFormValues,
        handleFormSubmit,
        isSubmiting,
        setPermission,
        setFormValues,
        setCheckedPermissions
    } = props;
            {/* <div className='card mt-3 mb-3'> */}

    useEffect(() => {
        if (formValues?.userType?.toString() === "2") {
            setPermission([{ value: '2', label: 'Special Discount' }])
            if (checkedPermissions?.includes("2")){
                setFormValues({ ...formValues, specialPermissions: "2" })
                setCheckedPermissions(["2"])
            }
            else{
                setFormValues({ ...formValues, specialPermissions: "" })
                setCheckedPermissions([])
            }
        }
        else
            setPermission([{ value: '1', label: 'View All User Data' }, { value: '2', label: 'Special Discount' }])
    }, [formValues?.userType])

    return (
        <>
                {/* <div className='card-header d-none'>
                    <h2>Settings</h2>
                </div> */}
                {/* <div className='card-body user-btns'> */}
                    {/* <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto d-none'>
                            <div className='d-flex mb-2 mt-3'>
                                {permission?.map((item) => {
                                    return (
                                        <div class="form-group mb-0 mr-3">
                                            <input
                                                type="checkbox"
                                                name="specialPermissions"
                                                id={item?.value}
                                                onChange={handlePermissionType}
                                                value={checkedPermissions}
                                                checked={formValues?.specialPermissions?.includes(item?.value)}
                                                className='input-checkbox'
                                            />
                                            <label for={item?.value} className='mr-2 mb-0 check-box-label'>{item?.label}</label>
                                        </div>
                                    )
                                })}
                                <div className="form-group mb-0 mr-3">
                                       <input
                                        type="checkbox"
                                        name="canViewCostingOverride"
                                        id="canViewCostingOverride"
                                        value={formValues?.canViewCostingOverride}
                                        checked={Boolean(formValues?.canViewCostingOverride)}
                                        onChange={handleCostingPermission}
                                        className="input-checkbox"
                                        />
                                        <label htmlFor="canViewCostingOverride" className='mr-2 mb-0 check-box-label'>View costing override</label>
                                    </div>
                            </div>
                        </div>
                    </div> */}
                {/* </div> */}
            {/* </div> */}
                <div className='row'>
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-6 col-sm-12 col-xs-12">
                        <div className='save-btns'>
                            <button className='btn cancel-btn' onClick={clearFormValues}>Cancel</button>
                            <button className='btn save-btn' type="submit" onClick={handleFormSubmit} disabled={isSubmiting}>
                                {formValues?.id ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default UserSettings